import React from 'react';
import '../styles/WhyChooseUs.css';

const WhyChooseUs = () => {
  const features = [
    {
      icon: 'fa-headset',
      title: 'Support',
      description: 'Get 24/7 customer support for all your travel needs and queries'
    },
    {
      icon: 'fa-shield-alt',
      title: 'Security',
      description: 'Your data and payments are protected with industry-leading security'
    },
    {
      icon: 'fa-star',
      title: 'Quality',
      description: 'Experience premium quality services and hand-picked destinations'
    }
  ];

  return (
    <section className="why-choose-us">
      <div className="container">
        <h2 className="section-title">What We Offer</h2>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                <i className={`fas ${feature.icon}`}></i>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
